const toSeconds = (timeStr) => timeStr
  .split(":")
  .reduce((total, value, index) => total + Number(value) * [3600, 60, 1][index], 0);

const getSessionSortValue = toSeconds;

const getDateTime = (timeStr, baseTime, dayOffset) => {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return new Date(baseTime.getFullYear(), baseTime.getMonth(), baseTime.getDate() + dayOffset, hours, minutes, seconds);
};

const getSessionWindow = (timeSlots, index, baseTime) => {
  const slot = timeSlots[index];
  const nextSlot = timeSlots[index + 1];
  const start = getDateTime(slot.time, baseTime, 0);

  if (!nextSlot) {
    return { start, end: getDateTime("00:00:00", baseTime, 1) };
  }

  return { start, end: getDateTime(nextSlot.time, baseTime, 0) };
};

module.exports = { getSessionSortValue, getSessionWindow };

if (require.main === module) {
  const slots = ["22:00:00", "20:00:00", "12:00:00", "10:00:00", "00:30:00"]
    .map((time) => ({ time }))
    .sort((a, b) => getSessionSortValue(a.time) - getSessionSortValue(b.time));
  const activeAt = (hours, minutes) => {
    const now = new Date(2026, 8, 8, hours, minutes, 0);
    return slots.findIndex((slot, index) => {
      const { start, end } = getSessionWindow(slots, index, now);
      return now >= start && now < end;
    });
  };

  if (slots.map(({ time }) => time).join(",") !== "00:30:00,10:00:00,12:00:00,20:00:00,22:00:00"
    || activeAt(22, 30) !== 4
    || activeAt(23, 59) !== 4
    || activeAt(0, 15) !== -1
    || activeAt(0, 30) !== 0) {
    throw new Error("coupon session time check failed");
  }

  console.log("coupon session time check passed");
}
